import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from './Sidebar';
import Stages from './Stages';
import TitleScreen from './TitleScreen';
import './App.scss';
import cowabunga from './Images/cowabunga.png';
import { setNumberOfPlayers } from './redux/stageList';
import { resetRun } from './redux/store';

function App() {
  const [showImage, setShowImage] = useState(false); // State for the cowabunga image
  const dispatch = useDispatch();
  const numberOfPlayers = useSelector(
    (state) => state.stageList.numberOfPlayers,
  );

  // Show the Cowabunga image
  const handleShowImage = () => setShowImage(true);

  // Hide the Cowabunga image
  const handleHideImage = () => setShowImage(false);

  const handlePlayerSelection = (players) => {
    dispatch(setNumberOfPlayers(players));
  };

  const handleResetRun = () => {
    const shouldReset = window.confirm('Reset current run and start over?');
    if (!shouldReset) {
      return;
    }

    setShowImage(false);
    dispatch(resetRun());
  };

  // Render the TitleScreen if no player count is selected
  if (numberOfPlayers === null) {
    return <TitleScreen onPlayerSelect={handlePlayerSelection} />;
  }

  return (
    <div className='app'>
      {/* Sidebar with a handler for showing the image */}
      <Sidebar
        handleShowImage={handleShowImage}
        numberOfPlayers={numberOfPlayers}
        onResetRun={handleResetRun}
      />

      {/* Stages layout based on selected number of players */}
      <Stages numberOfPlayers={numberOfPlayers} />

      {/* Cowabunga image container */}
      <div className='image-container'>
        {showImage && (
          <img
            src={cowabunga}
            alt='Cowabunga'
            className='cowabunga'
            onClick={handleHideImage}
          />
        )}
      </div>
    </div>
  );
}

export default App;
